// Workflow-spezifische Typen basierend auf ui-spec.md
import type { Project, ProjectStatus } from './index';

export type { Dringlichkeit } from './index';

// Workflow-Phasen
export type WorkflowPhase = 'vorplanung' | 'besichtigung' | 'kalkulation' | 'angebot';

// Projekt in der Workflow-Anzeige. Bis Oktober 2026 trug der Typ neun
// Zusatzfelder (bereiche_count, angebot_summe, waiting_person, …), die das
// Backend nie lieferte; die Karten zeigten dafür Platzhalter.
export type WorkflowProject = Project;

// UI-Sektionen für "Meine Arbeit"
export type WorkflowSection = 'neu' | 'in_arbeit' | 'warte_auf' | 'erledigt';

// Status zu Sektion Mapping
// Vollstaendiges Record: Ein neuer ProjectStatus ohne Eintrag hier ist ein
// Typfehler, kein stilles Verschwinden aus „Meine Arbeit“.
export const STATUS_TO_SECTION: Record<ProjectStatus, WorkflowSection> = {
  // NEU
  erfasst: 'neu',
  // IN ARBEIT — 'beauftragt' wartet auf einen Termin, 'in_umsetzung' laeuft;
  // beides ist Arbeit, die vor uns liegt, nicht erledigte.
  besichtigt: 'in_arbeit',
  beauftragt: 'in_arbeit',
  in_umsetzung: 'in_arbeit',
  // WARTE AUF
  angebot_raus: 'warte_auf',
  // ERLEDIGT — nur die Endzustaende (core PROJEKT_ENDZUSTAENDE)
  abgeschlossen: 'erledigt',
  abgelehnt: 'erledigt',
};

// Status zu Workflow-Phase Mapping. Absichtlich partiell: Die vier Phasen
// hier sind die Abschnitte der Projektseite (Vorplanung, Besichtigung,
// Kalkulation, Angebot). 'in_umsetzung' und 'abgeschlossen' bekommen ihre
// Abschnitte erst mit der Protokoll- und der Reviewseite (Ebene 5/6, eigene
// MRs) — bis dahin waere ein Eintrag ein Verweis auf eine Route, die es
// nicht gibt.
export const STATUS_TO_PHASE: Partial<Record<ProjectStatus, WorkflowPhase>> = {
  erfasst: 'vorplanung',
  besichtigt: 'kalkulation',
  angebot_raus: 'angebot',
};

// Warte-auf Gründe. 'gegenpruefung' und 'cto_freigabe' sind entfallen — beide
// gehoerten zur Freigabekette, die es im Solo-Betrieb nicht gibt.
export type WaitingReason = 'kunde' | 'versand';

// Nach dem Kollaps auf fuenf Status ist 'angebot_raus' der einzige Wartezustand.
export const STATUS_TO_WAITING_REASON: Partial<Record<ProjectStatus, WaitingReason>> = {
  angebot_raus: 'kunde',
};

// Progress Steps
export interface ProgressStep {
  id: WorkflowPhase;
  label: string;
  status: 'completed' | 'current' | 'upcoming';
}
